// @flow

function getDefaultCountry(): string {
  return sessionStorage.getItem('country') ?? '';
}

function getCurrentLanguage(): string {
  return sessionStorage.getItem('language') ?? '';
}

export {
  getDefaultCountry,
  getCurrentLanguage,
};
